module.exports = __webpack_public_path__ + "img/3.f379c76b.svg";